<template lang="pug">
	.help-page
		.close(v-on:click="closeTab()")
			.ico

		VueSlickCarousel(:arrows="true", :dots="true")
			.single(v-for="(item, index) in 15")
				img(:src="require(`@/assets/help-slides/${index+1}.svg`)", alt="")
			
</template>

<script>
	import VueSlickCarousel from 'vue-slick-carousel'
	export default {
		name: 'Help',
		components:{
			VueSlickCarousel
		},
		methods: {
			closeTab(){
				this.$router.push(window.baseURL);
			}
		}
	}
</script>